import { colors, getTestAttributes } from '@chillibean/component-library';
import { motion } from 'framer-motion';

export const icons = {
  animatedCheckCircleIcon: ({ fill = colors.blue.primary, height = 20, viewBox = '0 0 20 20', width = 20 } = {}) => {
    return (
      <svg fill="none" height={height} viewBox={viewBox} width={width} xmlns="http://www.w3.org/2000/svg">
        <motion.path
          animate={{
            opacity: 1,
            pathLength: 1,
            rotate: 0,
          }}
          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
          fill={fill}
          initial={{
            opacity: 0,
            pathLength: 0,
            rotate: -45,
          }}
        />
      </svg>
    );
  },
  animatedRoundIcon: ({ fill = colors.grey.primary, height = 20, viewBox = '0 0 20 20', width = 20 } = {}) => {
    return (
      <svg fill="none" height={height} viewBox={viewBox} width={width} xmlns="http://www.w3.org/2000/svg">
        <motion.path
          animate={{
            opacity: 1,
            pathLength: 1,
            rotate: 0,
          }}
          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
          fill={fill}
          fillOpacity="0.2"
          initial={{
            opacity: 0,
            pathLength: 0,
            rotate: -45,
          }}
        />
      </svg>
    );
  },
  checkWithCircleIcon: ({ fill = colors.blue.primary, height = 20, viewBox = '0 0 20 20', width = 20 } = {}) => {
    return (
      <svg
        fill="none"
        height={height}
        viewBox={viewBox}
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        {...getTestAttributes('check-with-circle-icon')}
      >
        <path
          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
          fill={fill}
        />
      </svg>
    );
  },
  crossIcon: ({ fill = colors.grey.primary, height = 20, viewBox = '0 0 20 20', width = 20 } = {}) => {
    return (
      <svg fill="none" height={height} viewBox={viewBox} width={width} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.0711 2.92898C13.1678 -0.974252 6.83216 -0.974252 2.92893 2.92898C-0.974297 6.83221 -0.974297 13.1679 2.92893 17.0711C6.83216 20.9743 13.1678 20.9743 17.0711 17.0711C20.9743 13.1679 20.9743 6.83221 17.0711 2.92898ZM12.8284 14.2427L10 11.4143L7.17157 14.2427L5.75736 12.8285L8.58579 10L5.75736 7.17162L7.17157 5.7574L10 8.58583L12.8284 5.7574L14.2426 7.17162L11.4142 10L14.2426 12.8285L12.8284 14.2427Z"
          fill={fill}
          fillOpacity="0.2"
        />
      </svg>
    );
  },
  plusIcon: ({ fill = colors.grey.primary, height = 20, opacity = 1, viewBox = '0 0 20 20', width = 20 } = {}) => {
    return (
      <svg fill="none" height={height} viewBox={viewBox} width={width} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H11V15H9V11H5V9H9V5H11V9H15V11Z"
          fill={fill}
          fillOpacity={opacity}
        />
      </svg>
    );
  },
  roundIcon: ({ fill = colors.grey.primary, height = 20, viewBox = '0 0 20 20', width = 20 } = {}) => {
    return (
      <svg
        fill="none"
        height={height}
        viewBox={viewBox}
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        {...getTestAttributes('round-icon')}
      >
        <path
          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
          fill={fill}
          fillOpacity="0.2"
        />
      </svg>
    );
  },
};

export default icons;
